import axios from 'axios';
import { FormikConfig } from 'formik';
import HttpService from '../services/HttpService';
import { IOmekaResp } from '../pages/ΟΑ/Registrations/RegistrationOrganisation';

export const retrieveInfoByAFM = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/aade/afm`, {
    params: values
  });
  return response;
};
export const retrieveInfoByName = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/aade/name`, {
    params: values
  });
  return response;
};
export const retrieveInfosByADT = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/aade/adt`, {
    params: values
  });
  return response;
};

export const confirmBank = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/confirm-bank`, {
    params: values
  });
  return response;
};

export const retrieveInfoByAMKA = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/hdika/info`, {
    params: values
  });
  return response;
};

export const retrievePAAYPAByAMKA = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/hdika/paaypa`, {
    params: values
  });
  return response;
};

export const retrieveAMKAByInfo = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/hdika/amka`, {
    params: values
  });
  return response;
};

export const retrieveForeasInfo = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/eparav/info`, {
    params: values
  });
  return response;
};

export const paidParavolaInfo = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/eparav/paravola/paid`, {
    params: values
  });
  return response;
};

export const usedParavolaInfo = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/eparav/paravola/used`, {
    params: values
  });
  return response;
};

export const refundParavolaInfo = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/eparav/paravola/refund`, {
    params: values
  });
  return response;
};

export const getAllForeasInfo = async () => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/eparav/foreis`);
  return response;
};

export const getAllCategoriesInfo = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/eparav/categories`, {
    params: values
  });
  return response;
};

export const getAllTypesInfo = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/eparav/types`, {
    params: values
  });
  return response;
};

export const getUserDetails = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/eparav/user`, {
    params: values
  });
  return response;
};

export const getParavoloType = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/eparav/type`, {
    params: values
  });
  return response;
};

export const getParavoloStatus = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/eparav/status`, {
    params: values
  });
  return response;
};

export const createParavolo = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/interoperability/eparav/create`, values);
  return response;
};

export const createParavoloShort = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/interoperability/eparav/create?short`, values);
  return response;
};

export const gemiAFMValidation = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/gemi/validate-afm`, {
    params: values
  });
  return response;
};

export const gemiBranchValidation = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/gemi/validate-branch`, {
    params: values
  });
  return response;
};

export const getGemiBoard = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/gemi/board`, {
    params: values
  });
  return response;
};

export const getGemiBoardV3 = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/interoperability/gemi/board`, values);
  return response;
};

export const getGemiInfo = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/gemi/info`, {
    params: values
  });
  return response;
};
export const getGemiInfoV3 = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/interoperability/gemi/info`, values);
  return response;
};

export const afeValidation = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/interoperability/afe/validation`, values);
  return response;
};

export const afeVersion = async () => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/afe/version`);
  return response;
};
export const afeIssue = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/interoperability/afe/issue`, values);
  return response;
};

export const fetchCollectionsOptions = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/optiokoakoustiko/parametrics/sulloges`);
  return resp.data;
};

export const fetchErgoTypesOptions = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/optiokoakoustiko/parametrics/erga`);
  return resp.data;
};

export const fetchTekmirioTypesOptions = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/optiokoakoustiko/parametrics/tekmiria`);
  return resp.data;
};

export const fetchOAtypeFormat = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/optiokoakoustiko/parametrics/type-formats`);
  return resp.data;
};

export const fetchContributorsTypesOptions = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/optiokoakoustiko/parametrics/contributors`);
  return resp.data;

};

export const fetchForeasDetails = async (id?: string) => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/foreas/${id}`);
  return resp.data;

};

export const fetchErgoDetails = async (id?: string) => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/ergo/${id}`);
  return resp.data;

};

export const fetchContributors = async (arrayIds?: Array<number>) => {
  const Ids = arrayIds?.join(',');
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/suntelestes/contributors?ids=${Ids}`);
  return resp;

};

export const fetchSullogesDetails = async (id?: string) => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/collections/${id}`);
  return resp.data;

};

export const fetchTekmirioDetails = async (id?: string) => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/tekmirio/${id}`);
  return resp.data;

};

export const fetchTekmirioMediaDetails = async (mediaArr: Array<number>) => {
  const urlParam = mediaArr.join(',');
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/tekmirio/media?collectionIds=${urlParam}`);
  return resp.data.data;
};

export const fetchOrganicMonadesParametrics = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/forms/unites`);
  return resp.data;
};

export const PUBLIC_fetchTomeasParametrics = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/forms/sections`);
  return resp.data;
};

export const fetchAllAdminFormsApplications =
  async (values: { page_length: number, page: number }) => {
    const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/forms`, {
      params: values
    });
    return resp.data;
  };

export const fetchAllAvailableApplicationForms = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/forms/public/applications`);
  return resp.data;
};


export const fetchSpecificApplicationForm = async (id: string) => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/forms/${id}`);
  return resp.data;
};


export const PUBLIC_fetchRegions = async () => {
  const resp = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/locations/parametrics/regions`);
  const options = resp?.data['o:terms'];
  return options;
};

export const PUBLIC_fetchLocationLevel1 = async () => {
  const resp = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/locations/parametrics/level1`);
  const options = resp?.data.data?.map((location: any) => {
    return {
      key: (location['o:title']),
      value: location['o:id']
    };
  });
  return options;
};
export const aadeKAD = async (values: FormikConfig<any>) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperability/aade/kad`, {
    params: values
  });
  return response;
};

export const getLoggedInUserDetails = async () => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users/user`);
  return response;
};

export const getForeas = async (foreas_id: string): Promise<{
  foreas: IOmekaResp | Record<string, never>,
  reverse: any
}> => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/foreas/${foreas_id}`);
  return {
    foreas: {
      id: foreas_id,
      organisationsUniqueCode: response.data.item['organisations:organisationsUniqueCode'][0]['@value'],
      orgIdentifierCountryId: response.data.item['organisations:orgIdentifierCountryId'][0]['@value'],
      organisationsName: response.data.item['organisations:organisationsName'][0]['@value'],
      organisationsAbbreviation: response.data.item['organisations:organisationsAbbreviation'][0]['@value'],
      organisationsEmail: response.data.item?.['organisations:organisationsEmail']?.[0]?.['@value'] || '',
      organisationsWebsite: response.data.item?.['organisations:organisationsWebsite']?.[0]?.['@value'] || '',
      organisationsTelephone: response.data.item?.['organisations:organisationsTelephone']?.[0]?.['@value'] || '',
      orgIdentifierFullAddress: response.data.item?.['organisations:orgIdentifierFullAddress']?.[0]?.['@value'] || '',
      organisationsCountry: response.data.item?.['organisations:organisationsCountry']?.[0]?.['@value'] || '',
      orgIdentifierComments: response.data.item?.['organisations:orgIdentifierComments']?.[0]?.['@value'] || '',
      orgIdentifierCommentsEn: response.data.item?.['organisations:orgIdentifierCommentsEn']?.[0]?.['@value'] || '',
      organisationsEnNameEn: response.data.item?.['organisations:organisationsEnNameEn']?.[0]?.['@value'] || '',
      orgIdentifierEnAbbreviation: response.data.item?.['organisations:orgIdentifierEnAbbreviation']?.[0]?.['@value'] || '',
    },
    reverse: response.data.reverse
  };
};
export const getCollection = async (collection_id: string): Promise<{
  collection: any,
  reverse: any
}> => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/collections/${collection_id}`);
  return {
    collection: {
      id: collection_id,
      collectionsUniqueCode: response.data.item?.['collections:collectionsUniqueCode']?.[0]?.['@value'] || '',
      collectionsIdentifierUniqueCode: response.data.item?.['collections:collectionsIdentifierUniqueCode']?.[0]?.['@value'] || '',
      collectionsTitle: response.data.item?.['collections:collectionsTitle']?.[0]?.['@value'] || '',
      collectionsEnTitle: response.data.item?.['collections:collectionsEnTitle']?.[0]?.['@value'] || '',
      collectionsDescription: response.data.item?.['collections:collectionsDescription']?.[0]?.['@value'] || '',
      collectionEnDescription: response.data.item?.['collections:collectionEnDescription']?.[0]?.['@value'] || '',
      collectionInternalFlag: response.data.item?.['collections:collectionInternalFlag']?.[0]?.['@value'] || '',
      collectionFeaturedFlag: response.data.item?.['collections:collectionFeaturedFlag']?.[0]?.['@value'] || '',
      organisationsUniqueCode: response.data.item?.['collections:organisationsUniqueCode']?.[0]?.['@value'] || '',
      collectionsComments: response.data.item?.['collections:collectionsComments']?.[0]?.['@value'] || '',
      collectionsCommentsEn: response.data.item?.['collections:collectionsCommentsEn']?.[0]?.['@value'] || '',
      collectionsRelateOrganisation: [{
        key: response.data.item?.['collections:collectionsRelateOrganisation']?.[0]?.['display_title'],
        value: response.data.item?.['collections:collectionsRelateOrganisation']?.[0]?.['value_resource_id']
      }]
    },
    reverse: response.data.reverse
  };
};

export const getDocument = async (document_id: string): Promise<{
  document: any,
  reverse: any,
}> => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/tekmirio/${document_id}`);

  return {
    document: {
      id: document_id,
      documentsUniqueCode: response.data?.['documents:documentsUniqueCode']?.[0]?.['@value'],
      documentIdentifier: response.data?.['documents:documentIdentifier']?.[0]?.['@value'],
      documentsID: response.data?.['documents:documentsID']?.[0]?.['@value'],
      documentsTitle: response.data?.['documents:documentsTitle']?.[0]?.['@value'],
      documentsRelationOrganisation: response.data?.['documents:documentIdentifier']?.[0]?.['@value'].split('_').slice(0, 2).join('_'),
      documentsRelationCollection: response.data?.['documents:documentsRelationCollection']?.[0]?.['display_title'],
      documentsEnTitle: response.data?.['documents:documentsEnTitle']?.[0]?.['@value'],
      documentsType: response.data?.['documents:documentsType']?.[0]?.['@value'],
      documentsDescription: response.data?.['documents:documentsDescription']?.[0]?.['@value'],
      documentsEnDescription: response.data?.['documents:documentsEnDescription']?.[0]?.['@value'],
      documentsDateCreation: response.data?.['documents:documentsDateCreation']?.[0]?.['@value'],
      documentsFormat: response.data?.['documents:documentsFormat']?.[0]?.['@value'],
      documentsDuration: response.data?.['documents:documentsDuration']?.[0]?.['@value'],
      documentsColor: response.data?.['documents:documentsColor']?.[0]?.['@value'],
      documentsSound: response.data?.['documents:documentsSound']?.[0]?.['@value'],
      documentsTechnical: response.data?.['documents:documentsTechnical']?.[0]?.['@value'],
      documentsSize: response.data?.['documents:documentsSize']?.[0]?.['@value'],
      documentsHeight: response.data?.['documents:documentsHeight']?.[0]?.['@value'],
      documentsWidth: response.data?.['documents:documentsWidth']?.[0]?.['@value'],
      documentsFrameRate: response.data?.['documents:documentsFrameRate']?.[0]?.['@value'],
      documentsAspectRatio: response.data?.['documents:documentsAspectRatio']?.[0]?.['@value'],
      documentsCopyright: response.data?.['documents:documentsCopyright']?.[0]?.['@value'],
      documentsLicence: response.data?.['documents:documentsLicence']?.[0]?.['@value'],
      documentsComments: response.data?.['documents:documentsComments']?.[0]?.['@value'],
      documentsEnComments: response.data?.['documents:documentsEnComments']?.[0]?.['@value'],
      documentsVimeoYtTitle: response.data?.['documents:documentsVimeoYtTitle']?.[0]?.['@value'],
      documentsVimeoYtUrl: response.data?.['documents:documentsVimeoYtUrl']?.[0]?.['@value'],
      documentsAttachedMediaImages: response.data?.['media'],
      documentsAttachedMediaFiles: response.data?.['attached_files'],
      documentsRelationProject: response.data?.['documents:documentsRelationProject']?.[0]?.['value_resource_id']
    },
    reverse: response.data.reverse
  };
};

export const getErgo = async (ergo_id: string): Promise<{
  project: any,
  reverse: any
}> => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/ergo/${ergo_id}`);
  return {
    project: {
      id: response.data.item?.['o:id'],
      projectIdentifier: response.data.item?.['projects:projectIdentifier']?.[0]?.['@value'],
      projectUniqueCode: response.data.item?.['projects:projectUniqueCode']?.[0]?.['@value'],
      projectTitle: response.data.item?.['projects:projectTitle']?.[0]?.['@value'],
      projectEnTitle: response.data.item?.['projects:projectEnTitle']?.[0]?.['@value'],
      projectAlternativeTitle: response.data.item?.['projects:projectAlternativeTitle']?.[0]?.['@value'],
      projectRelationWithTypeOfProject: response.data.item?.['projects:projectRelationWithTypeOfProject']?.[0]?.['@value'],
      projectRelationWithLocation: response.data.item?.['projects:projectRelationWithLocation']?.map((x: any) => {
        return { key: x?.['display_title'], value: x?.['value_resource_id'] };
      }),
      projectRelationWithDocument: response.data.item?.['projects:projectRelationWithDocument']?.[0]?.['display_title'],
      projectBelongsTo: response.data.item?.['projects:projectBelongsTo']?.[0]?.['@value'],
      projectLanguage: response.data.item?.['projects:projectLanguage']?.[0]?.['@value'],
      projectDuration: response.data.item?.['projects:projectDuration']?.[0]?.['@value'],
      projectCreativeCommons: response.data.item?.['projects:projectCreativeCommons']?.[0]?.['@value'],
      projectKeyword: response.data.item?.['projects:projectKeyword']?.[0]?.['@value'],
      projectEducational: response.data.item?.['projects:projectEducational']?.[0]?.['@value'],
      projectYear: response.data.item?.['projects:projectYear']?.[0]?.['@value'],
      projectCountry: response.data.item?.['projects:projectCountry']?.[0]?.['@value'],
      projectCopyright: response.data.item?.['projects:projectCopyright']?.[0]?.['@value'],
      projectComments: response.data.item?.['projects:projectComments']?.[0]?.['@value'],
      projectOrganisation: response.data.item?.['projects:projectOrganisation']?.[0]?.['@value'],
      projectTrainer: response.data.item?.['projects:projectTrainer']?.[0]?.['@value'],
      projectLab: response.data.item?.['projects:projectLab']?.[0]?.['@value'],
      projectCreationTeam: response.data.item?.['projects:projectCreationTeam']?.[0]?.['@value'],
      projectAward: response.data.item?.['projects:projectAward']?.[0]?.['@value'],
      projectDisplayRegion: response.data.item?.['projects:displayRegion']?.[0]?.['@value'],
      projectDescription: response.data.item?.['projects:projectDescription']?.[0]?.['@value'],
      projectEnDescription: response.data.item?.['projects:projectEnDescription']?.[0]?.['@value'],
      projectFormat: response.data.item?.['projects:projectFormat']?.[0]?.['@value'],
      projectColor: response.data.item?.['projects:projectColor']?.[0]?.['@value'],
      projectSound: response.data.item?.['projects:projectSound']?.[0]?.['@value'],
      projectSize: response.data.item?.['projects:projectSize']?.[0]?.['@value'],
      projectHeight: response.data.item?.['projects:projectHeight']?.[0]?.['@value'],
      projectWidth: response.data.item?.['projects:projectWidth']?.[0]?.['@value'],
      projectFrameRate: response.data.item?.['projects:projectFrameRate']?.[0]?.['@value'],
      projectAspectRatio: response.data.item?.['projects:projectAspectRatio']?.[0]?.['@value'],
      projectEnComments: response.data.item?.['projects:projectEnComments']?.[0]?.['@value'],
      projectEduInstitution: response.data.item?.['projects:projectEduInstitution']?.[0]?.['@value'],
      projectEduLevel: response.data.item?.['projects:projectEduLevel']?.[0]?.['@value'],
      projectNumberPlayers: response.data.item?.['projects:projectNumberPlayers']?.[0]?.['@value'],
      projectsMutualGoal: response.data.item?.['projects:projectsMutualGoal']?.[0]?.['@value'],
      projectOtherLocations: response.data.item?.['projects:projectOtherLocations']?.[0]?.['@value'],
      projectConnectorWithContributor: response.data.item?.['projects:projectConnectorWithContributor']?.map((x: any) => {
        return { key: x?.['o:title'], value: x?.['o:id'] };
      })
    },
    reverse: response.data.reverse
  };
};


export const getPopularCategories = async () => {
  const response = await HttpService.getAxiosClient().get(`/locations/popular`);

  return response.data?.map((x: any) => {
    return {
      key: x?.title,
      value: x?.id
    };
  });
};